import { GuestInfo } from './types';

export type GuestInfoErrors = Partial<Record<keyof GuestInfo, string>>;

const MIN_PHONE_DIGITS = 10;

export function validateGuestInfo(info: GuestInfo): GuestInfoErrors {
  const errors: GuestInfoErrors = {};

  if (info.phone.replace(/\D/g, '').length < MIN_PHONE_DIGITS) {
    errors.phone = 'Celular é obrigatório';
  }
  if (!info.name.trim()) {
    errors.name = info.lookupConfirmed ? 'Informe como podemos te chamar' : 'Nome é obrigatório';
  }

  if (!info.lookupConfirmed) {
    if (!info.street.trim()) errors.street = 'Rua é obrigatória';
    if (!info.number.trim()) errors.number = 'Número é obrigatório';
    if (!info.neighborhood.trim()) errors.neighborhood = 'Bairro é obrigatório';
    if (!info.city.trim()) errors.city = 'Cidade é obrigatória';
    if (!info.state.trim()) errors.state = 'Estado é obrigatório';
  }

  return errors;
}
